import StravaCompleteActivityTriggerIntegrationInstructionsComponent from '@cohort/components-xps/components/apps/strava/triggers/completeActivity/InstructionsComponent';
import type {StravaCompleteActivityTriggerStruct} from '@cohort/shared/apps/strava/triggers/completeActivity';
import {StravaCompleteActivityTriggerIntegrationSpec} from '@cohort/shared/apps/strava/triggers/completeActivity';
import StravaCompleteActivityTriggerIntegrationDetailComponent from '@cohort/wallet/apps/strava/triggerIntegrations/completeActivity/DetailComponent';
import type {TriggerIntegration} from '@cohort/wallet/apps/TriggerIntegration';

export const StravaCompleteActivityTriggerIntegration: TriggerIntegration<StravaCompleteActivityTriggerStruct> =
  {
    type: 'verification',
    spec: StravaCompleteActivityTriggerIntegrationSpec,
    detailsComponent: StravaCompleteActivityTriggerIntegrationDetailComponent,
    instructionsComponent: StravaCompleteActivityTriggerIntegrationInstructionsComponent,
    disableExponentialBackoff: true,
  };
